import React, { useState } from 'react';
 
import { EyeIcon, PencilIcon } from '@heroicons/react/24/outline'; // Import icons


const PaymentTable = () => {
    const [activeTab, setActiveTab] = useState('All');
  
  
    const tabs = ['All', 'Pending', 'Hold', 'Completed'];
  
    const  payments = [
      {
        sno: 1,
         saleorderno: '32432545',
        conformdate: '2024-09-26',
        workOrder: 'WO12345',
        name: 'kishore',
        
        status: 'process',
        statusColor: 'orange',
   
      },
      {
        sno: 2,
        saleorderno: '32432545',
        conformdate: '2024-09-26',
        workOrder: 'WO12345',
        name: 'madhesh',
        
        status: 'completed',
        statusColor: 'green',
   
      },
    ];
  
    const filteredPayment =  payments.filter(( payments) => {
      if (activeTab === 'Pending') {
        return  payments.status === 'process';
      } else if (activeTab === 'Hold') {
        return  payments.status === 'Vibro Polish';
      } else if (activeTab === 'Completed') {
        return  payments.status === 'c\ompleted';
      }
      return true;
    });
  
    
    const handleView = ( payment) => {
      console.log('View client:',  payment);
      // Handle view logic here, e.g., navigate to a detail page
    };
  
    const handleEdit = ( payment) => {
      console.log('Edit client:',  payment);
      // Handle edit logic here, e.g., navigate to an edit form
    };
  
    return (
      <div className="w-full p-4 overflow-hidden rounded-lg shadow-xs">
        <div className="flex justify-end">
         
        </div>
        <div className="flex mb-4">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`flex-1 py-2 px-2 text-center text-sm sm:text-base ${
                activeTab === tab
                  ? 'bg-black poppins-bold text-white'
                  : 'bg-gray-100 poppins-regular text-gray-600'
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
  
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs poppins-semibold tracking-wide text-left text-gray-500 uppercase border-b dark1:border-gray-700 bg-gray-50 dark1:text-gray-400 dark1:bg-gray-800">
                <th className="px-4 py-3">S.No</th>
                <th className="px-4 py-3">Sales order number</th>
                <th className="px-4 py-3">Customer Name</th>
                <th className="px-4 py-3">Confirmed Date</th>
                <th className="px-4 py-3">Work Order</th>
                {/* <th className="px-4 py-3">Qty</th> */}
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3">Actions</th> {/* Add Actions column */}
              </tr>
            </thead>
            <tbody className="bg-white poppins-regular divide-y dark1:divide-gray-700 dark1:bg-gray-800">
              {filteredPayment.map(( payment, index) => (
                <tr key={index} className="text-gray-700 dark1:text-gray-400">
                  <td className="px-4 py-3 text-sm">{ payment.sno}</td>
                  <td className="px-4 py-3 text-sm">
                    <p className="font-semibold">{ payment. saleorderno}</p>
                  </td>
                  <td className="px-4 py-3 text-sm">{ payment.name}</td>

                  <td className="px-4 py-3 text-sm">{ payment.conformdate}</td>
                  <td className="px-4 py-3 text-sm">{ payment.workOrder}</td>
                  {/* <td className="px-4 py-3 text-sm">{client.qty}</td> */}
                  <td className="px-4 py-3 text-sm">
                    <div className="flex flex-col">
                      <span
                        className={`px-2 py-1 font-semibold text-center leading-tight text-${ payment.statusColor}-700 bg-${ payment.statusColor}-100 rounded-full`}
                      >
                        { payment.status}
                      </span>
                       
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm">
                    <div className="flex space-x-2">
                      {/* View icon */}
                      <EyeIcon
                        className="h-5 w-5 text-gray-500 hover:text-black cursor-pointer"
                        onClick={() => handleView( payment)}
                      />
                      {/* Edit icon */}
                      <PencilIcon
                        className="h-5 w-5 text-gray-500 hover:text-black cursor-pointer"
                        onClick={() => handleEdit( payment)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

export default PaymentTable